import React from 'react';
import Tooltip from 'components/Tooltip';

const SentimentFilters = (props) => {
    const {toggleSentimentFilters, sentimentFilters, updatingCount, sentimentCount} = props;
    return (
        <div className="home-page-filters__filter-container mt-2">
            <div style={{fontWeight: '700'}}>Sentiment</div>
            <div style={{display: 'flex'}} className="home-page-filters__sentiment-container">
                <Tooltip placement="bottom" wide tooltip={`Show/hide positive results`}>
                    <div className="home-page-filters__sentiment-item"
                         onClick={() => toggleSentimentFilters('positive')}>
                        <div className="filter-icon"
                             style={{backgroundColor: 'none', color: '#2eb85c', fontSize: '35px'}}
                        >
                            <i className="far fa-smile"/>
                        </div>
                        {sentimentFilters['positive'] &&
                        <div className="filter-icon-checkmark" style={{backgroundColor: '#2eb85c', color: 'white'}}>
                            <i className="fas fa-check"/>
                        </div>
                        }
                        {!updatingCount && sentimentCount.positive !== null &&
                        <div className="filter-icon-count">
                            {sentimentCount.positive}
                        </div>
                        }
                    </div>
                </Tooltip>
                <Tooltip placement="bottom" wide tooltip={`Show/hide neutral results`}>
                    <div className="home-page-filters__sentiment-item"
                         onClick={() => toggleSentimentFilters('neutral')}>
                        <div className="filter-icon"
                             style={{backgroundColor: 'none', color: '#ced2d8', fontSize: '35px'}}
                             data-tip="Show/hide neutral results"
                        >
                            <i className="far fa-meh"/>
                        </div>
                        {sentimentFilters['neutral'] &&
                        <div className="filter-icon-checkmark" style={{backgroundColor: '#ced2d8', color: 'white'}}>
                            <i className="fas fa-check"/>
                        </div>
                        }
                        {!updatingCount && sentimentCount.neutral !== null &&
                        <div className="filter-icon-count">
                            {sentimentCount.neutral}
                        </div>
                        }
                    </div>
                </Tooltip>
                <Tooltip placement="bottom" wide tooltip={`Show/hide negative results`}>
                    <div className="home-page-filters__sentiment-item"
                         onClick={() => toggleSentimentFilters('negative')}>
                        <div className="filter-icon"
                             style={{backgroundColor: 'none', color: '#e55353', fontSize: '35px'}}
                        >
                            <i className="far fa-frown"/>
                        </div>
                        {sentimentFilters['negative'] &&
                        <div className="filter-icon-checkmark" style={{backgroundColor: '#e55353', color: 'white'}}>
                            <i className="fas fa-check"/>
                        </div>
                        }
                        {!updatingCount && sentimentCount.negative !== null &&
                        <div className="filter-icon-count">
                            {sentimentCount.negative}
                        </div>
                        }
                    </div>
                </Tooltip>
            </div>
        </div>
    );
};

export default SentimentFilters;
